import { useState, useEffect } from 'react';
import useRouter from 'hooks/use-router';
function useRedirect() {
  const { push } = useRouter()
  const [url, setUrl] = useState('')

  useEffect(() => {
    const urlRedirect = localStorage.getItem('url_redirect')
    setUrl(urlRedirect)
  }, [])

  const redirect = () => {
    push(url)
  }

  const setRedirect = (url: string) => {
    localStorage.setItem('url_redirect', url)
    setUrl(url)
  }

  const clearRedirect = () => {
    localStorage.removeItem('url_redirect')
    setUrl(null)
  }
  
  return [{url}, {redirect, setRedirect, clearRedirect}]
}

export default useRedirect